export default __webpack_public_path__ + "static/media/qlik-sense.c6def6d2.png";